[
  {
    "id": "lecon_1_1",
    "numero": "1.1",
    "module": 1,
    "duree_minutes": 20,
    "theme": "Introduction aux variables, types et fonctions en Kotlin",
    "access": "full",
    "fr": {
      "titre": "Introduction aux variables, types et fonctions en Kotlin",
      "objectif": "Comprendre les bases de Kotlin : déclarer des variables, utiliser les types de données et créer des fonctions simples",
      "preview_theorie": "Kotlin est un langage de programmation moderne utilisé pour développer des applications Android. Il permet de déclarer des variables avec des types de données spécifiques comme Int, String, Boolean, etc. Les fonctions sont des blocs de code réutilisables qui effectuent des…"
    },
    "en": {
      "titre": "Introduction to Kotlin: variables, types and functions",
      "objectif": "Understand how to declare variables, know the basic types, and create simple functions in Kotlin.",
      "preview_theorie": "Kotlin is a statically typed language that runs on the JVM. Variables are declared with the keywords val (immutable) or var (mutable). Basic types include Int, Double, Boolean, String, and Char. A function is defined with the keyword fun, followed by the name, parameters in…"
    }
  },
  {
    "id": "lecon_1_2",
    "numero": "1.2",
    "module": 1,
    "duree_minutes": 20,
    "theme": "Sécurité nulle et Smart Cast en Kotlin",
    "access": "full",
    "fr": {
      "titre": "Sécurité nulle et Smart Cast en Kotlin",
      "objectif": "Comprendre les concepts de sécurité nulle et de smart cast en Kotlin pour éviter les erreurs de pointeur nul dans l'application Todo",
      "preview_theorie": "En Kotlin, la sécurité nulle est une fonctionnalité clé qui aide à prévenir les erreurs de pointeur nul (NullPointerException). Par défaut, les types en Kotlin ne peuvent pas être nuls. Si vous voulez qu'une variable puisse être nulle, vous devez utiliser le type nullable en…"
    },
    "en": {
      "titre": "Null Safety and Smart Cast in Kotlin",
      "objectif": "Understand null safety and smart cast concepts in Kotlin to prevent null pointer errors in the Todo app",
      "preview_theorie": "In Kotlin, null safety is a key feature that helps prevent null pointer exceptions. By default, types in Kotlin cannot be null. If you want a variable to be nullable, you must use the nullable type by adding a question mark (?) after the type. For example, String? can be either…"
    }
  },
  {
    "id": "lecon_1_3",
    "numero": "1.3",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Classes, Objets et Héritage en Kotlin",
    "access": "full",
    "fr": {
      "titre": "Classes, Objets et Héritage en Kotlin",
      "objectif": "Comprendre comment créer des classes, instancier des objets et utiliser l'héritage en Kotlin pour structurer une application Todo Android.",
      "preview_theorie": "En Kotlin, une classe est un modèle qui décrit les caractéristiques et les comportements d'un objet. On la déclare avec le mot-clé 'class'. Par exemple, dans notre application Todo, une tâche peut être modélisée par une classe TodoItem avec des propriétés comme le titre, la…"
    },
    "en": {
      "titre": "Classes, Objects and Inheritance in Kotlin",
      "objectif": "Understand how to create classes, instantiate objects and use inheritance in Kotlin to structure an Android Todo application.",
      "preview_theorie": "In Kotlin, a class is a blueprint that describes the characteristics and behaviors of an object. It is declared with the 'class' keyword. For example, in our Todo application, a task can be modeled by a TodoItem class with properties like title, description and completion…"
    }
  },
  {
    "id": "lecon_1_4",
    "numero": "1.4",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Collections : List, Map et Filter en Kotlin",
    "access": "teaser",
    "fr": {
      "titre": "Collections : List, Map et Filter en Kotlin",
      "objectif": "Apprendre a creer et manipuler des listes de taches avec les collections Kotlin : List, Map et Filter, afin de gerer les taches de notre application Todo.",
      "preview_theorie": "Les collections sont des structures de donnees qui permettent de stocker plusieurs elements. En Kotlin, il en existe plusieurs types, mais nous allons nous concentrer sur les trois plus utiles pour debuter.\n\nLA LISTE (List)\nUne List est une collection ordonnee d elements. Elle…"
    },
    "en": {
      "titre": "Collections: List, Map and Filter in Kotlin",
      "objectif": "Learn to create and manipulate task lists with Kotlin collections: List, Map and Filter, in order to manage tasks in our Todo application.",
      "preview_theorie": "Collections are data structures that allow you to store multiple elements. In Kotlin, there are several types, but we will focus on the three most useful ones for beginners.\n\nTHE LIST\nA List is an ordered collection of elements. It can be immutable (listOf) or mutable…"
    }
  },
  {
    "id": "lecon_1_5",
    "numero": "1.5",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Fonctions Lambda et d'ordre supérieur en Kotlin",
    "access": "teaser",
    "fr": {
      "titre": "Fonctions Lambda et d'ordre supérieur en Kotlin",
      "objectif": "Comprendre et utiliser les fonctions Lambda et d'ordre supérieur pour manipuler les collections dans une application Android.",
      "preview_theorie": "Les fonctions Lambda en Kotlin sont des fonctions anonymes qui peuvent être passées comme argument à d'autres fonctions. Elles sont utiles pour traiter les collections de manière concise. Les fonctions d'ordre supérieur sont des fonctions qui prennent soit une fonction en…"
    },
    "en": {
      "titre": "Lambdas and Higher-Order Functions in Kotlin",
      "objectif": "Understand and use Lambdas and Higher-Order Functions to manipulate collections in an Android Todo app.",
      "preview_theorie": "Lambdas in Kotlin are anonymous functions that can be passed as arguments. They are useful for concise collection processing. Higher-order functions take a function as an argument or return a function. In a Todo Android app, you can use higher-order functions like 'filter',…"
    }
  },
  {
    "id": "lecon_1_6",
    "numero": "1.6",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Coroutines et fonctions suspendues en Kotlin",
    "access": "teaser",
    "fr": {
      "titre": "Coroutines et fonctions suspendues en Kotlin",
      "objectif": "Comprendre les bases des coroutines et comment utiliser les fonctions suspendues pour gérer les opérations asynchrones",
      "preview_theorie": "Les coroutines sont un mécanisme puissant en Kotlin pour gérer les opérations asynchrones de manière plus simple et plus lisible que les callbacks traditionnels. Une coroutine est essentiellement une fonction qui peut être suspendue et reprise plus tard sans bloquer le thread…"
    },
    "en": {
      "titre": "Coroutines and suspend functions in Kotlin",
      "objectif": "Understand the basics of coroutines and how to use suspend functions to handle asynchronous operations",
      "preview_theorie": "Coroutines are a powerful mechanism in Kotlin for managing asynchronous operations in a simpler and more readable way than traditional callbacks. A coroutine is essentially a function that can be suspended and resumed later without blocking the current thread. Suspend functions…"
    }
  },
  {
    "id": "lecon_1_7",
    "numero": "1.7",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Structure d'un projet Android Studio moderne avec Jetpack Compose",
    "access": "teaser",
    "fr": {
      "titre": "Structure d'un projet Android Studio moderne avec Jetpack Compose",
      "objectif": "Comprendre la structure moderne d'un projet Android Studio utilisant Jetpack Compose, apprendre à créer des composants déclaratifs et gérer l'état.",
      "preview_theorie": "Jetpack Compose est une bibliothèque déclarative pour construire des interfaces utilisateur sur Android. Elle remplace XML en permettant de définir l'UI directement dans le code Kotlin via des composants déclaratifs. Ces composants, appelés composables, décrivent l'UI en…"
    },
    "en": {
      "titre": "Modern Android Studio Project Structure with Jetpack Compose",
      "objectif": "Understand the modern Android Studio project structure using Jetpack Compose, learn to create declarative UI components and manage state.",
      "preview_theorie": "Jetpack Compose is a declarative UI toolkit for Android. It replaces XML by allowing UI definition directly in Kotlin code through declarative components. These components, called composables, describe the UI based on the application's state. The modern structure includes…"
    }
  },
  {
    "id": "lecon_1_8",
    "numero": "1.8",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Comprendre le Cycle de Vie d'une Activity Android",
    "access": "teaser",
    "fr": {
      "titre": "Comprendre le Cycle de Vie d'une Activity Android",
      "objectif": "Maîtriser les étapes du cycle de vie d'une Activity Android et savoir réagir aux changements d'état pour gérer correctement les ressources.",
      "preview_theorie": "Une Activity est un composant essentiel d'une application Android qui fournit une interface utilisateur à l'écran. Son cycle de vie est géré par le système d'exploitation et se compose d'un ensemble de méthodes de rappel (callbacks) auxquelles l'application peut se brancher pour…"
    },
    "en": {
      "titre": "Understanding the Android Activity Lifecycle",
      "objectif": "Master the stages of the Android Activity lifecycle and know how to react to state changes to correctly manage resources.",
      "preview_theorie": "An Activity is a core Android component that provides a user interface on the screen. Its lifecycle is managed by the operating system and consists of a set of callback methods that the app can hook into to execute code at specific times. The lifecycle starts when the user…"
    }
  },
  {
    "id": "lecon_1_9",
    "numero": "1.9",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Layouts XML et ConstraintLayout",
    "access": "teaser",
    "fr": {
      "titre": "Layouts XML et ConstraintLayout",
      "objectif": "Apprendre à utiliser ConstraintLayout pour créer des interfaces graphiques flexibles et efficaces.",
      "preview_theorie": "Le ConstraintLayout est un layout Android qui permet de positionner des composants de manière très précise en utilisant des contraintes. Il remplace le RelativeLayout dans de nombreux cas, offrant une plus grande flexibilité et une meilleure performance. Les contraintes…"
    },
    "en": {
      "titre": "XML Layouts and ConstraintLayout",
      "objectif": "Learn to use ConstraintLayout to create flexible and efficient user interfaces.",
      "preview_theorie": "ConstraintLayout is an Android layout that allows precise positioning of components using constraints. It replaces RelativeLayout in many cases, offering greater flexibility and better performance. Constraints define relationships between components (e.g., 'View1 must be above…"
    }
  },
  {
    "id": "lecon_1_10",
    "numero": "1.10",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Modifier Row, Column et Box dans Jetpack Compose",
    "access": "teaser",
    "fr": {
      "titre": "Modifier Row, Column et Box dans Jetpack Compose",
      "objectif": "Comprendre comment disposer des composables en ligne, en colonne et dans des boîtes, et savoir les imbriquer correctement",
      "preview_theorie": "Dans Jetpack Compose, la disposition des éléments de l'interface se fait grâce à des contraintes déclaratives qui remplacent les approches imperatives de XML. Trois composables de base couvrent la plupart des besoins de mise en page : Row, Column et Box. Un Row aligne ses…"
    },
    "en": {
      "titre": "Modifier Row, Column and Box in Jetpack Compose",
      "objectif": "Understand how to arrange composables in a row, column, and box, and how to nest them correctly",
      "preview_theorie": "In Jetpack Compose, laying out UI elements is done with declarative constraints that replace the imperative XML approaches. Three core layout composables cover most layout needs: Row, Column, and Box. A Row aligns its children horizontally, distributing any remaining space…"
    }
  },
  {
    "id": "lecon_1_11",
    "numero": "1.11",
    "module": 1,
    "duree_minutes": 25,
    "theme": "LazyColumn et LazyRow dans Jetpack Compose",
    "access": "teaser",
    "fr": {
      "titre": "LazyColumn et LazyRow dans Jetpack Compose",
      "objectif": "Maîtriser l'affichage de listes verticales et horizontales avec LazyColumn et LazyRow dans Jetpack Compose",
      "preview_theorie": "Dans Jetpack Compose, LazyColumn et LazyRow remplacent les RecyclerView traditionnels pour afficher des listes de manière efficace. LazyColumn crée des listes verticales tandis que LazyRow crée des listes horizontales. Ces composants ne rendent que les éléments visibles à…"
    },
    "en": {
      "titre": "LazyColumn and LazyRow in Jetpack Compose",
      "objectif": "Master vertical and horizontal lists display with LazyColumn and LazyRow in Jetpack Compose",
      "preview_theorie": "In Jetpack Compose, LazyColumn and LazyRow replace traditional RecyclerViews for displaying lists efficiently. LazyColumn creates vertical lists while LazyRow creates horizontal lists. These components only render visible items on screen, optimizing performance. LazyColumn uses…"
    }
  },
  {
    "id": "lecon_1_12",
    "numero": "1.12",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Navigation entre écrans avec Jetpack Compose Navigation",
    "access": "teaser",
    "fr": {
      "titre": "Navigation entre écrans avec Jetpack Compose Navigation",
      "objectif": "Maîtriser la navigation déclarative entre plusieurs écrans dans Jetpack Compose",
      "preview_theorie": "La navigation entre les écrans dans Jetpack Compose repose sur un système de graphiques de navigation déclaré dans un fichier de type NavHost. Chaque écran est représenté par une destination identifiée par une chaîne de route, et la transition d’un écran à un autre s’effectue en…"
    },
    "en": {
      "titre": "Navigation Between Screens with Jetpack Compose Navigation",
      "objectif": "Master declarative navigation across multiple screens in Jetpack Compose",
      "preview_theorie": "The navigation system in Jetpack Compose is built around a navigation graph hosted by a NavHost composable. Each screen corresponds to a destination identified by a route string, and moving from one screen to another is performed by calling navController.navigate(route) from a…"
    }
  },
  {
    "id": "lecon_1_13",
    "numero": "1.13",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Permissions Android : Demander et gérer les permissions en temps réel",
    "access": "teaser",
    "fr": {
      "titre": "Permissions Android : Demander et gérer les permissions en temps réel",
      "objectif": "Comprendre comment demander, vérifier et déclarer les permissions à l'exécution dans une application Android, et savoir les gérer de manière réactive.",
      "preview_theorie": "Dans le développement Android moderne, les permissions constituent une barrière essentielle entre l'application et les fonctionnalités du système d'exploitation. Les permissions sont classées en deux catégories : les permissions dangerous, qui nécessitent l'accord explicite de…"
    },
    "en": {
      "titre": "Android Permissions: Requesting and Managing Runtime Permissions",
      "objectif": "Understand how to declare, request, and handle runtime permissions in an Android app, and learn how to manage them reactively.",
      "preview_theorie": "In modern Android development, permissions act as a critical barrier between your app and the operating system's features. Permissions are divided into two groups: normal permissions, which are granted automatically at install time, and dangerous permissions, which must be…"
    }
  },
  {
    "id": "lecon_1_14",
    "numero": "1.14",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Leçon 1.14 - DataStore pour stocker des données localement : remplacement moderne de SharedPreferences",
    "access": "teaser",
    "fr": {
      "titre": "Leçon 1.14 - DataStore pour stocker des données localement : remplacement moderne de SharedPreferences",
      "objectif": "Comprendre comment utiliser DataStore pour stocker des données de manière sécurisée et moderne sur Android",
      "preview_theorie": "DataStore est la nouvelle bibliothèque recommandée par Google pour le stockage de données sur Android, conçue pour remplacer SharedPreferences. Contrairement à SharedPreferences qui stocke les données sous forme de paires clé-valeur avec un accès synchrone, DataStore offre deux…"
    },
    "en": {
      "titre": "Lesson 1.14 - DataStore for local data storage: modern replacement for SharedPreferences",
      "objectif": "Understand how to use DataStore to store data securely and modernly on Android",
      "preview_theorie": "DataStore is Google's new recommended library for data storage on Android, designed to replace SharedPreferences. Unlike SharedPreferences which stores data as key-value pairs with synchronous access, DataStore offers two implementations: Proto DataStore for structured data…"
    }
  },
  {
    "id": "lecon_1_15",
    "numero": "1.15",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Projet fil rouge : construire une app Todo complete avec Jetpack Compose",
    "access": "teaser",
    "fr": {
      "titre": "Projet fil rouge : construire une app Todo complete avec Jetpack Compose",
      "objectif": "À la fin de cette leçon, l'apprenant sera capable de concevoir et implémenter une application Todo fonctionnelle en utilisant Jetpack Compose, en intégrant les concepts vus dans les leçons précédentes (Composables, state, layout, etc.).",
      "preview_theorie": "Jetpack Compose est un toolkit moderne pour construire des UI natives sur Android. Dans ce projet fil rouge, nous allons créer une application Todo complète qui permet d'ajouter, de lister, de marquer comme terminée et de supprimer des tâches. Cette application nous permettra de…"
    },
    "en": {
      "titre": "Capstone Project: Build a Complete Todo App with Jetpack Compose",
      "objectif": "By the end of this lesson, the learner will be able to design and implement a functional Todo application using Jetpack Compose, integrating concepts from previous lessons (Composables, state, layout, etc.).",
      "preview_theorie": "Jetpack Compose is a modern toolkit for building native UI on Android. In this capstone project, we will create a complete Todo app that allows adding, listing, marking as completed, and deleting tasks. This app will let us practice key Compose concepts: Composables, state…"
    }
  },
  {
    "id": "lecon_1_16",
    "numero": "1.16",
    "module": 1,
    "duree_minutes": 30,
    "theme": "ViewModel et architecture MVVM en Kotlin",
    "access": "teaser",
    "fr": {
      "titre": "ViewModel et architecture MVVM en Kotlin",
      "objectif": "Comprendre l'architecture MVVM et savoir utiliser ViewModel pour gérer l'état de l'UI de manière réactive et persistante",
      "preview_theorie": "L'architecture MVVM (Model-View-ViewModel) est une approche de conception d'applications Android qui sépare clairement la logique métier, la logique d'affichage et l'état de l'interface utilisateur. Le Model représente les données et la logique métier, la View est l'interface…"
    },
    "en": {
      "titre": "ViewModel and MVVM Architecture in Kotlin",
      "objectif": "Understand the MVVM architecture and learn to use ViewModel to manage UI state reactively and persistently",
      "preview_theorie": "The MVVM (Model-View-ViewModel) architecture is a design approach for Android applications that clearly separates business logic, display logic, and user interface state. The Model represents data and business logic, the View is the user interface (Compose composables or XML…"
    }
  },
  {
    "id": "lecon_1_17",
    "numero": "1.17",
    "module": 1,
    "duree_minutes": 30,
    "theme": "Room Database et stockage local",
    "access": "teaser",
    "fr": {
      "titre": "Room Database et stockage local",
      "objectif": "Comprendre comment utiliser Room Database pour stocker et récupérer des données localement dans une application Android",
      "preview_theorie": "Room Database est la couche d'abstraction recommandée par Google pour travailler avec des bases de données SQLite sur Android. Room fournit une abstraction au-dessus de SQLite qui permet d'accéder à la base de données de manière plus conviviale et plus sûre, tout en conservant…"
    },
    "en": {
      "titre": "Room Database and Local Storage",
      "objectif": "Understand how to use Room Database to store and retrieve data locally in an Android application",
      "preview_theorie": "Room Database is Google's recommended abstraction layer for working with SQLite databases on Android. Room provides an abstraction over SQLite that allows accessing the database in a more convenient and safe way, while preserving the power of SQL.\n\nRoom consists of three main…"
    }
  },
  {
    "id": "lecon_1_18",
    "numero": "1.18",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Navigation avancée avec Compose Navigation",
    "access": "teaser",
    "fr": {
      "titre": "Navigation avancée avec Compose Navigation",
      "objectif": "Maîtriser les fonctionnalités avancées de Compose Navigation pour créer des applications Android complexes",
      "preview_theorie": "Compose Navigation est la bibliothèque recommandée par Google pour gérer la navigation entre les écrans dans les applications Jetpack Compose. Elle fournit un système déclaratif pour définir les graphiques de navigation, gérer la back stack, et passer des arguments entre les…"
    },
    "en": {
      "titre": "Advanced Navigation with Compose Navigation",
      "objectif": "Master advanced Compose Navigation features for building complex Android applications",
      "preview_theorie": "Compose Navigation is Google's recommended library for managing navigation between screens in Jetpack Compose applications. It provides a declarative system to define navigation graphs, manage the back stack, and pass arguments between destinations.\n\nBeyond the basic…"
    }
  },
  {
    "id": "lecon_1_19",
    "numero": "1.19",
    "module": 1,
    "duree_minutes": 30,
    "theme": "Coroutines et Flow pour les opérations asynchrones",
    "access": "teaser",
    "fr": {
      "titre": "Coroutines et Flow pour les opérations asynchrones",
      "objectif": "Comprendre et maîtriser les coroutines Kotlin et Flow pour gérer efficacement les opérations asynchrones dans une application Android",
      "preview_theorie": "Les coroutines Kotlin sont un mécanisme léger pour l'exécution asynchrone qui permet d'écrire du code asynchrone de manière séquentielle et lisible. Contrairement aux threads traditionnels qui sont coûteux en ressources, les coroutines peuvent être des milliers à s'exécuter sur…"
    },
    "en": {
      "titre": "Coroutines and Flow for Asynchronous Operations",
      "objectif": "Understand and master Kotlin coroutines and Flow to efficiently handle asynchronous operations in an Android application",
      "preview_theorie": "Kotlin coroutines are a lightweight mechanism for asynchronous execution that allows writing asynchronous code in a sequential and readable manner. Unlike traditional threads which are resource-intensive, thousands of coroutines can run on just a few threads. They are ideal for…"
    }
  },
  {
    "id": "lecon_1_20",
    "numero": "1.20",
    "module": 1,
    "duree_minutes": 25,
    "theme": "Tests unitaires et tests d'interface utilisateur",
    "access": "teaser",
    "fr": {
      "titre": "Tests unitaires et tests d'interface utilisateur",
      "objectif": "Comprendre les différentes approches de test en Android et savoir écrire des tests unitaires et des tests d'interface utilisateur",
      "preview_theorie": "Les tests sont essentiels pour garantir la qualité et la fiabilité d'une application Android. Il existe plusieurs types de tests : les tests unitaires, qui testent des fonctions ou classes individuelles en isolation ; les tests d'intégration, qui testent l'interaction entre…"
    },
    "en": {
      "titre": "Unit Tests and UI Testing",
      "objectif": "Understand different testing approaches in Android and learn to write unit tests and UI tests",
      "preview_theorie": "Testing is essential to ensure the quality and reliability of an Android application. There are several types of tests: unit tests, which test individual functions or classes in isolation; integration tests, which test the interaction between multiple components; and UI tests,…"
    }
  },
  {
    "id": "lecon_2_1",
    "numero": "2.1",
    "module": 2,
    "duree_minutes": 30,
    "theme": "Architecture d'application et Clean Architecture",
    "access": "teaser",
    "fr": {
      "titre": "Architecture d'application et Clean Architecture",
      "objectif": "Comprendre les principes de l'architecture logicielle et appliquer le pattern Clean Architecture dans une application Android",
      "preview_theorie": "L'architecture d'une application détermine comment le code estorganisée en couches et comment ces couches interagissent. Une bonne architecture rend le code plus maintenable, testable, et évolutable. Les patterns architecturaux populaires incluent MVC (Model-View-Controller),…"
    },
    "en": {
      "titre": "Application Architecture and Clean Architecture",
      "objectif": "Understand software architecture principles and apply Clean Architecture pattern in an Android application",
      "preview_theorie": "Application architecture determines how code is organized into layers and how these layers interact. Good architecture makes code more maintainable, testable, and evolvable. Popular architectural patterns include MVC (Model-View-Controller), MVP (Model-View-Presenter), and MVVM…"
    }
  },
  {
    "id": "lecon_2_2",
    "numero": "2.2",
    "module": 2,
    "duree_minutes": 25,
    "theme": "Dependency Injection avec Hilt",
    "access": "teaser",
    "fr": {
      "titre": "Dependency Injection avec Hilt",
      "objectif": "Comprendre le concept de Dependency Injection et savoir utiliser Hilt pour gérer les dépendances dans une application Android",
      "preview_theorie": "La Dependency Injection (DI) est un pattern de conception qui permet de fournir les dépendances d'une classe de manière externe plutôt que de les créer à l'intérieur. Cela rend le code plus testable, modulaire et découplé. Au lieu qu'une classe crée ses dépendances avec 'new',…"
    },
    "en": {
      "titre": "Dependency Injection with Hilt",
      "objectif": "Understand the Dependency Injection concept and learn to use Hilt to manage dependencies in an Android application",
      "preview_theorie": "Dependency Injection (DI) is a design pattern that provides dependencies to a class externally rather than creating them internally. This makes code more testable, modular, and decoupled. Instead of a class creating its dependencies with 'new', it receives them via constructor,…"
    }
  }
]